export default "__VITE_ASSET__abfbe470__"